import { render, staticRenderFns } from "./techAchievementForm.vue?vue&type=template&id=36c61498&scoped=true&"
import script from "./techAchievementForm.vue?vue&type=script&lang=js&"
export * from "./techAchievementForm.vue?vue&type=script&lang=js&"
import style0 from "./techAchievementForm.vue?vue&type=style&index=0&id=36c61498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c61498",
  null
  
)

export default component.exports